import { useState, useEffect } from "react";
import ReportsAPI from "../../../api/ReportsAPI";

const useFetchReports = (period = null) => {
	const [loading, setLoading] = useState(false);
	const [reports, setReports] = useState([]);

	const fetchReports = async () => {
		setLoading(true);
		try {
			const result = await ReportsAPI.getReports(period);
			setReports(result);
		} catch (error) {
			console.error("Failed to fetch reports:", error);
			setReports([]);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchReports();
	}, [period]); // re-fetch whenever period changes.

	return {
		reports,
		loading,
		refetch: fetchReports,
	};
};

export default useFetchReports;
